import clsx from "clsx";

import { Switch } from "react-migration/components/Switch";

type FilterToggleProps = {
  name: string;
  prefix?: string;
  color: string;
  enabled: boolean;
  setEnabled: () => void;
  disabled?: boolean;
  hidePrefix?: boolean;
};
// TODO: Move this somewhere more shared
export const FilterToggle = ({ name, prefix, color, enabled, setEnabled, disabled, hidePrefix }: FilterToggleProps) => (
  <div className="flex justify-between">
    <div className="flex items-center space-x-2">
      {!hidePrefix && (
        <div
          style={{ backgroundColor: color }}
          className={`flex items-center justify-center rounded-full p-2 text-white h-6 w-6`}
        >
          <div>{name.substring(0, 1).toUpperCase()}</div>
        </div>
      )}
      <div className={clsx("font-bold", { "opacity-50": disabled })}>{name}</div>
    </div>
    <Switch
      id={`${prefix ?? "planning"}-${name}`}
      label={name}
      disabled={disabled}
      onToggle={setEnabled}
      value={enabled}
    />
  </div>
);
